module.exports = __webpack_public_path__ + "img/productHome7.d1c138a4.png";